/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LineTop/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromFormat from 'Data/format.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function LineTop({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/TopBar/CustomResource/Content/Content/CustomResource/Content/Resource/Trigger/Indicator/LineTop"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let customResourceItemIsFirstValueData = fromData.useDataFormat({ viewPath,
context: 'custom_resource_item',
path: 'isFirst',
format: fromFormat.not,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(customResourceItemIsFirstValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}